export default __webpack_public_path__ + "img/landscape_2.434eee0d4f12df3b2bc43a8acf6d8a5e.jpg";